<div class="container">
    <div class="banner">
        <div class="declaration">
            <h2>Use our new <u>space estimator</u> to find the unit size for your needs</h2>
            <p>Explore <u (click)="populate_generic_unit_sizes(1)">small</u>, <u (click)="populate_generic_unit_sizes(2)">medium</u>, or <u (click)="populate_generic_unit_sizes(3)">large units</u></p>
        </div>
        <div class="unit-image1">
            <img src="/assets/standalone/banner-render1.png" alt="storage-unit-render">
        </div>
        <div class="unit-image2">
            <img src="/assets/standalone/banner-render2.png" alt="storage-unit-render">
        </div>
    </div>
</div>